import React from 'react';
import { Link } from 'react-router-dom';
import NotFoundMessage from '#component/general/not-found-message';
import PreloaderComponent from '#component/preloader';
import WarehouseAccordion from './warehouse-accordion';
import WarehousesContainer from './warehouses-container';
import { CallToActionButton } from './styles';

export const Warehouses = props => {
  const {
    warehouses,
    loading,
    userType,
    showAllIndex,
    setShowAllIndex,
    setWarehouse,
    setAnchorEl,
    noData
  } = props;
  if (noData) {
    return (
      <WarehousesContainer {...props}>
        {userType < 10 ?
          <CallToActionButton
            variant="contained"
            color="secondary"
            component={Link}
            to="/create-warehouse"
          >
            Create site
          </CallToActionButton> :
          <NotFoundMessage>
            All your applications will appear here soon
          </NotFoundMessage>}
      </WarehousesContainer>
    );
  }

  if (!warehouses?.length && !loading) {
    return (
      <WarehousesContainer {...props}>
        <NotFoundMessage>
          No sites
        </NotFoundMessage>
      </WarehousesContainer>
    );
  }

  if (!warehouses?.length && loading) {
    return <PreloaderComponent />;
  }

  return (
    <WarehousesContainer {...props}>
      {
        warehouses.map(wh => (
          <WarehouseAccordion
            key={wh.id}
            userType={userType}
            warehouse={wh}
            showAllIndex={showAllIndex}
            expanded={true}
            setShowAllIndex={setShowAllIndex}
            setWarehouse={setWarehouse}
            setAnchorEl={setAnchorEl}
          />
        ))
      }
    </WarehousesContainer>
  );
};
